import Settings from "./settings";

const axios = require("axios");

export class Api {
    baseUrl = Settings.baseUrl;

    params(obj) {
        return Object.keys(obj).map(function (k) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k])
        }).join('&')
    }

    get(url,body) {        
        return this.getFullUrl(this.fullUrl(url), body)
    }

    fullUrl(url) {
        url = url.replace('/api/apiqueryview/','/queryview/');
        return this.baseUrl + url;
    }

    getFullUrl(fullUrl,body) {
        axios.defaults.headers.common['Authorization'] =
            'Bearer ' + localStorage.getItem('token');
        var opts = {
            withCredentials: true
        };
        if(body)
            opts.params = body;
        return axios
            .get(fullUrl, opts);
    }
    download(url) {
        return this.downloadFullUrl(this.fullUrl(url));
    }
    downloadFullUrl(fullUrl) {
        return axios({
            url: fullUrl,
            method: 'GET',        
            responseType: 'blob',
        
        }).then((response) => {        
             var fileURL = window.URL.createObjectURL(new Blob([response.data]));        
             var fileLink = document.createElement('a');

             var fName = 'file.csv';
             if(response.headers['content-disposition']) {
                var s = response.headers['content-disposition'].split('filename=');
                if(s.length > 1) {
                    fName = s[1].split(";")[0].replaceAll('\"','');
                }
             }
        
             fileLink.href = fileURL;
             fileLink.setAttribute('download', fName);
             document.body.appendChild(fileLink);        
             fileLink.click();        
        });
    }

    post(url, data) {        
        return this.postFullUrl(this.fullUrl(url), data);
    }

    postFullUrl(fullUrl, data) {
        axios.defaults.headers.common['Authorization'] =
            'Bearer ' + localStorage.getItem('token');
        return axios
            .post(fullUrl, data, {
                withCredentials: true
            });
    }

    put(url, data) {
        return this.putFullUrl(this.fullUrl(url), data);
    }

    putFullUrl(fullUrl, data) {
        axios.defaults.headers.common['Authorization'] =
            'Bearer ' + localStorage.getItem('token');
        return axios
            .put(fullUrl, data, {
                withCredentials: true
            });
    }
    delete(url, data) {
        return this.deleteFullUrl(this.fullUrl(url), data);
    }

    deleteFullUrl(fullUrl, data) {
        axios.defaults.headers.common['Authorization'] =
            'Bearer ' + localStorage.getItem('token');
        return axios
            .delete(fullUrl, data, {
                withCredentials: true
            });
    }

    login(userName, pwd) {
        var data = {
            "Username": userName,
            "Password": pwd
        }

        this.logout();        
        //var url = this.baseUrl + '/account/login';
        var url = this.baseUrl + '/api/auth/login';
        
        return axios.post(url, data, {
            withCredentials: false,
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            var usr =  JSON.stringify(res.data.user);
            if(!usr) {
                alert('Kombinationen användarnamn/lösenord verkar vara felaktigt. Försök igen.');
                return;
            }
            //alert(res.data);
            localStorage.setItem('user',usr);
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('expires', res.data.expires);
            axios.defaults.headers.common['Authorization'] =
                'Bearer ' + localStorage.getItem('token');


        });
    }

    logout() {
        //TODO: Gör en aktiv logout med anrop till servern för snabbare rensing av cache
        // axios.defaults.headers.common['Authorization'] = null;
        delete axios.defaults.headers.common["Authorization"];
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('expires');
    }

    keepalive() {
        var p = { url: window.top.location.href ?? "" };
        var ls = localStorage.getItem('latestactive');
        if(ls) {
            var d = new Date(JSON.parse(ls));            
            if(((new Date())-d) < 1.5*Settings.keepAliveTimeMs)
                p.uiactivity = 1;
        }        
        console.log('Keeping alive: '+JSON.stringify(p));
        return this.post("/api/auth/keepalive", p);
        //return this.post("/auth/keepalive", p);
    }
}







